import { baseUrl } from "../../../config/url-config/index";
import axiosInstance from "../axiosInstance";

const Patch = async (path, data) => {
  const result = await axiosInstance.patch(`${baseUrl}/${path}`, data);
  return result;
};

export default Patch;
